<span [ngClass]="{ 'inline-emoji': isEmoji }" slateString [context]="context" [viewContext]="viewContext"></span>
